// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"db365621","31":"0a59b743","390":"d3e4099e","455":"73b9f9a7","583":"f70fc76a","644":"e361c3fe","896":"9aeac7a2"}[chunkId] + ".chunk.js";
};